import { loadConfig } from "./scrpits/utils";
import {
  getHistData,
  getSimulatedRates,
  getAverageRate,
  getQuantile,
  getStandardDeviation,
} from "./scrpits/calcHelper";

async function startCalcDynamic(input) {


  const constants = await loadConfig();

  let inflationrate = constants.inflationrate; 
  if (input.adjustInflation){
    inflationrate = input.inflationrate;
  }

  // Get the period lengths
  //------------------------------

  let periodLengths = Array(input.years).fill(1);

  let years = [...Array(input.years).keys()];

  let periods = [];
  let shift = 0;
  periodLengths.forEach((p, i) => {
    periods.push(years.slice(shift, shift + p));
    shift += p;
  });
  //---------------------------------------------

  // Simulate period Rates for all TrailRuns
  //----------------------------------
  let simulatedRates = await getSimulatedRates(
    periods,
    constants.simulationRuns
  );
  //---------------------------------

  let resultRates = simulatedRates.resultRates;
  let expectedYearlyYieldRate = await getAverageRate();

  let expectedTotalRate =
    expectedYearlyYieldRate * input.riskPortionRate +
    constants.risklessRate * (1 - input.riskPortionRate);
 let defaultExpectedTotalRate = expectedTotalRate;
  
  let simulationResults = resultRates.map((x) =>
    x.map((y, i) => {
      

      let adjustedPeriodLength = undefined;
      let isWithdrawalPeriod = false;
      let isLastWithdrawalPeriod = false;
      if (i % input.periodLength === 0 && input.periodLength !== 1 ) {
        isWithdrawalPeriod = true;
        adjustedPeriodLength = Math.max(
          Math.min(input.periodLength, input.years - (i)),
          1
        );

        let weight = (input.years - i + 1 - adjustedPeriodLength)/(input.years - i);

       expectedTotalRate = defaultExpectedTotalRate*weight+constants.risklessRate*(1-weight);

        if (input.years - (i + 1) < input.periodLength) {
          // annuityFactor = 1;
          isLastWithdrawalPeriod = true;
        }
      }

      let annuityFactor =
        ((1 + expectedTotalRate) ** (input.years - i - 1) *
          (expectedTotalRate - inflationrate)) /
        ((1 + expectedTotalRate) ** (input.years - i) -
          (1 + inflationrate) ** (input.years - i));

      return {
        riskRate: y,
        risklessRate: 1 + constants.risklessRate - 1,
        periodMaxWithdrawal:
          input.maxWithdrawal * (1 + inflationrate) ** i,
        annuityFactor: annuityFactor,
        isWithdrawalPeriod: isWithdrawalPeriod,
        adjustedPeriodLength: adjustedPeriodLength,
        isLastWithdrawalPeriod: isLastWithdrawalPeriod,
      };
    })
  );

  simulationResults = simulationResults.map(
    (simulationResultsLine, simulationRun) => {
      let prevPeriodSavings = input.savings;
      let prevRiskSavings = input.savings * input.riskPortionRate;
      let prevRisklessSavings = input.savings * (1 - input.riskPortionRate);

      let endPeriodSavings = 0;
      let endPeriodRiskSavings = 0;
      let endPeriodRisklessSavings = 0;

      let withdrawal = 0;
      let  totalWithdrawal = 0;

      let realWithdrawal = 0;
      let lastWithdrawal = 0;
      simulationResultsLine.forEach((simulation, period) => {
        withdrawal = prevPeriodSavings * simulation.annuityFactor;
        if (input.useMaxWithdrawal) {
          withdrawal = Math.min(
            simulation.periodMaxWithdrawal,
            withdrawal
          );
        }

        // Do we realy want a withdrawal, or do we have an adjustment period? For Periods <> 1 we need to skip
        if (input.periodLength !== 1) {
          // Check, if we are in an withdrawal period
          
          if (simulation.isWithdrawalPeriod) {
            let steps = [...Array(simulation.adjustedPeriodLength).keys()];
             if (simulation.isLastWithdrawalPeriod) {
              totalWithdrawal = prevPeriodSavings;
              let dividor = steps.reduce(
                (p, c) => p + (1 + inflationrate) ** c / (1 + simulation.risklessRate) ** c,
                0
              );
              withdrawal = totalWithdrawal/dividor;
              if (input.useMaxWithdrawal) {
                withdrawal = Math.min(
                  simulation.periodMaxWithdrawal,
                  withdrawal
                );
              }
             } 
            
            totalWithdrawal =
            steps.reduce(
              (p, c) =>
                p +
                withdrawal *
                  ((1 + inflationrate) ** c /
                    (1 + constants.risklessRate) ** c),
              0
            );
             
            
            endPeriodRiskSavings = Math.max(
              0,
              (prevPeriodSavings - totalWithdrawal) *
                input.riskPortionRate *
                (1 + simulation.riskRate)
            );
    
            endPeriodRisklessSavings = Math.max(
              0,
              (prevPeriodSavings - totalWithdrawal) *
                (1 - input.riskPortionRate) *
                (1 + simulation.risklessRate)
            );
      
          } 
          else {
            endPeriodRiskSavings = 
            (prevPeriodSavings) *
              input.riskPortionRate *
              (1 + simulation.riskRate)
          ;
  
          endPeriodRisklessSavings = 
            (prevPeriodSavings) *
              (1 - input.riskPortionRate) *
              (1 + simulation.risklessRate)
;
            withdrawal = lastWithdrawal * (1 + inflationrate);
          }
          lastWithdrawal = withdrawal;
        } else {
        endPeriodRiskSavings = Math.max(
          0,
          (prevPeriodSavings - withdrawal) *
            input.riskPortionRate *
            (1 + simulation.riskRate)
        );

        endPeriodRisklessSavings = Math.max(
          0,
          (prevPeriodSavings - withdrawal) *
            (1 - input.riskPortionRate) *
            (1 + simulation.risklessRate)
        );
        }

        realWithdrawal = periods[period].reduce(
          (p, c) => p + withdrawal / (1 + inflationrate) ** c,
          0
        );

        endPeriodSavings = endPeriodRiskSavings + endPeriodRisklessSavings;
        prevRiskSavings = prevPeriodSavings * input.riskPortionRate;
        prevRisklessSavings = prevPeriodSavings * (1 - input.riskPortionRate);


        simulationResults[simulationRun][period] = {
          prevRiskSavings: prevRiskSavings,
          prevRisklessSavings: prevRisklessSavings,
          prevPeriodSavings: prevPeriodSavings,
          endPeriodSavings: endPeriodSavings,
          endPeriodRiskSavings: endPeriodRiskSavings,
          endPeriodRisklessSavings: endPeriodRisklessSavings,
          withdrawal: withdrawal,
          risklessRate: simulation.risklessRate,
          riskRate: simulation.riskRate,
          periodLength: simulation.periodLength,
          expectedTotalRate: expectedTotalRate,
          annuityFactor: simulation.annuityFactor,
          realWithdrawal: realWithdrawal,
        };

        prevPeriodSavings = endPeriodSavings;
      });

      return simulationResultsLine;
    }
  );

  let realWithdrawals = simulationResults.map((x) =>
    x.map((y) => y.realWithdrawal)
  );

  let realWithdrawalsFlat = realWithdrawals.flat();

  let avgRealWithdrawal =
    realWithdrawalsFlat.reduce((p, c) => p + c, 0) / realWithdrawalsFlat.length;

  let avgRealWithdrawalsResults = Array(periods.length).fill(0);

  realWithdrawals.forEach((simulation) => {
    simulation.forEach((periodRealWithdrawal, period) => {
      avgRealWithdrawalsResults[period] +=
        periodRealWithdrawal / realWithdrawals.length;
    });
  });

  let realAvgEndSavings =
    simulationResults.reduce((p, c) => {
      return p + c.slice(-1)[0].endPeriodSavings;
    }, 0) / simulationResults.length;

  return {
    simulationResults: simulationResults,
    avgRealWithdrawal: avgRealWithdrawal,
    brokeCounter: 0,
    avgBrokeYear: Math.round(0),
    withdrawal: {
      avgRealWithdrawal: avgRealWithdrawal,
      realWithdrawalsQ5: getQuantile(realWithdrawalsFlat, 0.05),
      realWithdrawalsQ12_5: getQuantile(realWithdrawalsFlat, 0.125),
      realWithdrawalsQ25: getQuantile(realWithdrawalsFlat, 0.25),
      realWithdrawalsQ50: getQuantile(realWithdrawalsFlat, 0.5),
      realWithdrawalsQ75: getQuantile(realWithdrawalsFlat, 0.75),
      realWithdrawalsQ87_5: getQuantile(realWithdrawalsFlat, 0.875),
      realWithdrawalsQ95: getQuantile(realWithdrawalsFlat, 0.95),
      realWithdrawalsQ99: getQuantile(realWithdrawalsFlat, 0.9995),
      realWithdrawalsStandardDeviation:
        getStandardDeviation(realWithdrawalsFlat),
      realWithdrawalMax: realWithdrawalsFlat.reduce(
        (a, b) => Math.max(a, b),
        -Infinity
      ),
      realWithdrawalMin: realWithdrawalsFlat.reduce(
        (a, b) => Math.min(a, b),
        Infinity
      ),
      realWithdrawalAvgByPeriod: avgRealWithdrawalsResults,
      realAvgEndSavings: realAvgEndSavings,
      realWithdrawalsChartData: realWithdrawals.map((x) => {
        return x.map((y, i) => {
          return { year: i + 1, value: y, avg: avgRealWithdrawal };
        });
      }),
    },
    histData: getHistData(realWithdrawalsFlat, "Realer Konsum"),
  };
}

export { startCalcDynamic };
